var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-4 md:mx-20 lg:mx-0 px-4 mb-2"},[(_vm.component)?_c(_vm.component,{tag:"component",attrs:{"item":_vm.item}}):_c('div',[_c('div')])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }